import Layout from '@/Shared/Layout';
export default {
  layout: Layout,
  props: {
    message: String
  }
};